<script>
    import Carousel from 'svelte-carousel';
    import { store } from '../../store.js';
    export let carousel;
    export let imageWidth = $store.type === 'pc' ? 120 : 50;
    export let vcWidth = $store.type === 'pc' ? 150: 100;
    export let oneRow = true;
</script>

{#if oneRow}
<div class="vcs-logo text-center">
    <img src={`/images/vcs/alphanonce.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/lost.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/obcapital.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/raffaello.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/huobi.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/vistalabs.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
</div>
{:else}
<div class="vcs-logo text-center">
    <img src={`/images/vcs/alphanonce.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/lost.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/obcapital.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
</div>
<div class="vcs-logo text-center">
    <img src={`/images/vcs/raffaello.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/huobi.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
    <img src={`/images/vcs/vistalabs.png`} alt="" style={`width: ${$store.r * vcWidth}px; height: ${$store.r * vcWidth}px;object-fit:contain;`} />
</div>
{/if}

<Carousel
    autoplay
    autoplayDuration={5000}
    particlesToShow={$store.type === 'pc' ? 6 : 4}
    particlesToScroll={$store.type === 'pc' ? 6 : 4}
    arrows={false}
    dots={false}
    bind:this={carousel}
    let:showPrevPage
    let:showNextPage
>
    {#each Array(32) as _, i}
        {#if i > 0 && i !== 5 && i !== 2 && i !== 30}
            <div class="brand-logo">
                <img 
                    src={`/images/partners/logo_${i}.png`} 
                    alt={`logo_${i}`}
                    style={`
                        width: ${imageWidth}px; 
                        height: ${imageWidth}px;
                        object-fit:contain;
                    `} 
                />
            </div>
        {/if}
    {/each}
</Carousel>

<style>
    .vcs-logo img {
        border-radius: 20px;
        box-shadow: 1px 5px 10px 5px #ababab;
        margin: 10px;
    }

</style>